// extracted by mini-css-extract-plugin
export var errorIcon = "_mp-1";
export var nameLogo = "_mp-0";